import { useMsal } from '@azure/msal-react';
import { LogOut, Settings as SettingsIcon } from 'lucide-react';
import { useState } from 'react';
import { About } from '@/components/About';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface SettingsProps {
  readonly className?: string;
}

export function Settings({ className = 'w-5 h-5' }: SettingsProps) {
  const [showAbout, setShowAbout] = useState(false);
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="w-8 h-8 flex items-center justify-center hover:bg-[#3d3d3d] rounded cursor-pointer"
          >
            <SettingsIcon className={className} aria-label="Settings" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setShowAbout(true)}>
            About
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={handleLogout}
            className="text-red-600 focus:text-red-600"
          >
            <LogOut className="mr-2 h-4 w-4" />
            <span>Logout</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={showAbout} onOpenChange={setShowAbout}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>About Maintenance Monitor</DialogTitle>
          </DialogHeader>
          <About />
        </DialogContent>
      </Dialog>
    </>
  );
}
